module.exports = __webpack_public_path__ + "img/2V.1.9228f569.jpg";